/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

require('node_modules/whatwg-fetch/dist/fetch.umd');
require('node_modules/components-jqueryui/jquery-ui.js');
require('node_modules/jquery-ui-touch-punch/jquery.ui.touch-punch.js');
require('node_modules/backbone.localstorage/build/backbone.localStorage.js');
require('frontend/assets/js/lib/jquery.bind-first.js');
require('frontend/assets/js/lib/jquery.inputmask.js');
require('frontend/assets/js/lib/jquery.inputmask-multi.js');
require('node_modules/jquery-lazyload/jquery.lazyload.js');
require('node_modules/easyzoom/src/easyzoom.js');
require('node_modules/backbone.paginator/lib/backbone.paginator.js');
require('node_modules/moment/locale/ru.js');
require('node_modules/jquery-countdown/dist/jquery.countdown.js');
require('node_modules/video.js/dist/video.js');
require('node_modules/videojs-flash/dist/videojs-flash.js');
require('node_modules/vshushkov-audiojs/audiojs/audio.js');
require('node_modules/owl.carousel2/dist/owl.carousel.js');
require('node_modules/suggestions-jquery/dist/js/jquery.suggestions.js');
require('node_modules/textarea-autosize/dist/jquery.textarea_autosize.js');
require('node_modules/store2/src/store2.js');
require('node_modules/floatthead/dist/jquery.floatThead.js');
window.smartcrop = require('node_modules/smartcrop/smartcrop.js');
window.Compressor = require('node_modules/compressorjs/dist/compressor');
require('vendor/yiisoft/yii2/assets/yii.js');
require('vendor/yiisoft/yii2/assets/yii.activeForm.js');
require('vendor/yiisoft/yii2-authclient/src/assets/authchoice.js');
require('frontend/assets/js/lib/als.js');
require('frontend/assets/js/lib/jquery.mousewheel.js');
require('frontend/assets/js/lib/jquery.highlight.js');
require('frontend/assets/js/lib/jTweener.js');
require('frontend/assets/js/lib/scroller.js');
require('frontend/assets/js/mixins/item-in-viewport-mixin.js');
require('frontend/assets/js/mixins/in-viewport-mixin.js');
require('frontend/assets/js/mixins/cart-discount-mixin.js');
require('frontend/assets/js/mixins/close-popup-mixin.js');
require('frontend/assets/js/lebedev/global/integer-input.js');
window.als.Popup = require('frontend/assets/js/react/common/es6/libs/popup.js').Popup;
require('frontend/assets/js/lebedev/global/rolling-number.js');
require('frontend/assets/js/lebedev/global/search.js');
require('frontend/assets/js/lebedev/global/switcher.js');
require('frontend/assets/js/lebedev/global/vertical-fixer.js');
_.assign(app, require('frontend/assets/js/react/common/es6/oko-data.js'));
require('frontend/assets/js/history/History.js');
require('frontend/assets/js/routers/Router.js');
require('frontend/assets/js/routers/CartRouter.js');
require('frontend/assets/js/routers/AuthRouter.js');
require('frontend/assets/js/routers/NewsRouter.js');
require('frontend/assets/js/helpers/url-helper.js');
require('frontend/assets/js/helpers/RedirectHelper.js');
require('frontend/assets/js/helpers/HtmlHelper.js');
require('frontend/assets/js/helpers/DeclinationHelper.js');
require('frontend/assets/js/helpers/NumberHelper.js');
require('frontend/assets/js/helpers/IsMobileHelper.js');
require('frontend/assets/js/helpers/oko-helper.js');
require('frontend/assets/js/helpers/vk-targeting-helper.js');
require('frontend/assets/js/helpers/DateHelper.js');
require('frontend/assets/js/helpers/CookieHelper.js');
app.helpers.DomHelper = require('frontend/assets/js/react/common/helpers/dom-helper.js');
require('frontend/assets/js/helpers/TemplateHelper.js');
require('frontend/assets/js/helpers/ErrorHelper.js');
require('frontend/assets/js/helpers/DaDataHelper.js');
require('frontend/assets/js/helpers/PhoneHelper.js');
require('frontend/assets/js/helpers/string-helper.js');
require('frontend/assets/js/helpers/storage-helper.js');
require('frontend/assets/js/helpers/BrowserDetectHelper.js');
require('frontend/assets/js/helpers/popup-positioning-helper.js');
require('frontend/assets/js/helpers/object-helper.js');
require('frontend/assets/js/helpers/mutation-observer-helper.js');
require('frontend/assets/js/helpers/cqc-helper.js');
app.helpers.FiltersHelper = require('frontend/assets/js/react/common/helpers/filter-helper.js');
app.helpers.InputHelper = require('frontend/assets/js/react/common/helpers/input-helper.js');
require('frontend/assets/js/data/phone-codes.js');
require('frontend/assets/js/data/api-fields.js');
require('frontend/assets/js/data/country-flags.js');
app.View = require('frontend/assets/js/react/common/es6/components/view.js').View;
app.Model = require('frontend/assets/js/react/common/es6/components/model.js').Model;
app.Collection = require('frontend/assets/js/react/common/es6/components/collection.js').Collection;
require('frontend/assets/js/components/ItemsView.js');
require('frontend/assets/js/components/rest-common-view.js');
require('frontend/assets/js/components/CategoriesView.js');
require('frontend/assets/js/components/TabsListView.js');
require('frontend/assets/js/components/tabs-base-item-view.js');
app.FormView = require('frontend/assets/js/react/common/es6/views/form-view.js').FormView;
require('frontend/assets/js/components/ValidatedFormView.js');
require('frontend/assets/js/components/MessageFormView.js');
require('frontend/assets/js/components/CallMeFormView.js');
require('frontend/assets/js/components/NotAuthMessageView.js');
require('frontend/assets/js/components/CommonAuthFormView.js');
require('frontend/assets/js/components/ManagerGradeFormView.js');
require('frontend/assets/js/components/common-city-phone-view.js');
require('frontend/assets/js/components/item-pageable-collection.js');
require('frontend/assets/js/components/BaseTemplatedView.js');
require('frontend/assets/js/components/BasePaginationView.js');
require('frontend/assets/js/components/SelectView.js');
require('frontend/assets/js/components/redux-dispatches-view.js');
require('frontend/assets/js/filters/collections/filters.js');
app.ChosenFilters = require('frontend/assets/js/react/common/es6/collections/chosen-filters.js').ChosenFilters;
require('frontend/assets/js/filters/components/BaseFilterView.js');
require('frontend/assets/js/filters/components/section-filter-view.js');
require('frontend/assets/js/filters/components/checkbox-view.js');
require('frontend/assets/js/filters/components/Checkbox.js');
require('frontend/assets/js/filters/components/checkbox-list-view.js');
require('frontend/assets/js/filters/components/CheckboxList.js');
require('frontend/assets/js/filters/views/bottom-tree-filter-view.js');
require('frontend/assets/js/components/fader-base-view.js');
require('frontend/assets/js/views/fader-view.js');
require('frontend/assets/js/views/infinite-scroll-view.js');
require('frontend/assets/js/views/popups/items-popup-view.js');
require('frontend/assets/js/views/cart/cart-remote-popup-view.js');
require('frontend/assets/js/views/popups/remote-items-popup-view.js');
require('frontend/assets/js/views/popups/fast-delivery-popup-view.js');
require('frontend/assets/js/views/popups/min-sum-order-popup-view.js');
require('frontend/assets/js/views/star-rating-view.js');
require('frontend/assets/js/views/chponk/chponk-common-view.js');
require('frontend/assets/js/views/chponk/chponk-view.js');
require('frontend/assets/js/views/chponk/chponk-pack-view.js');
require('frontend/assets/js/views/item-view/rest-items-view.js');
require('frontend/assets/js/views/pagination/get-param-pagination-view.js');
require('frontend/assets/js/views/pagination/pagination-button-view.js');
require('frontend/assets/js/views/pagination/pagination-view.js');
require('frontend/assets/js/views/pagination/cart-pagination-view.js');
require('frontend/assets/js/views/cart/cart-reordering-popup-view.js');
require('frontend/assets/js/views/cart/cart-discounts-view.js');
require('frontend/assets/js/views/cart/cart-tabs-view.js');
require('frontend/assets/js/views/cart/cart-common-view.js');
require('frontend/assets/js/views/cart/cart-upsale-view.js');
require('frontend/assets/js/views/cart/cart-transit-message-view.js');
require('frontend/assets/js/views/cart/cart-remains-view.js');
require('frontend/assets/js/views/cart/cart-remains-popup-view.js');
require('frontend/assets/js/views/phone-inputmask-view.js');
require('frontend/assets/js/views/password-input-view.js');
require('frontend/assets/js/views/entity-input-form-view.js');
app.ItemQtyView = require('frontend/assets/js/react/common/es6/views/item-qty-view.js').ItemQtyView;
require('frontend/assets/js/views/service/service-item-qty-view.js');
require('frontend/assets/js/views/service/service-order-status-view.js');
require('frontend/assets/js/views/cart/cart-item-qty-view.js');
require('frontend/assets/js/views/item-view/item-view.js');
require('frontend/assets/js/views/cart/cart-fast-delivery-view.js');
require('frontend/assets/js/views/cart/cart-bill-view.js');
require('frontend/assets/js/views/cart/cart-status-view.js');
require('frontend/assets/js/views/cart/cart-gift-message-view.js');
require('frontend/assets/js/views/claims/claim-upload-form-view.js');
require('frontend/assets/js/views/claims/claims-common-view.js');
require('frontend/assets/js/views/claims/claim-view.js');
require('frontend/assets/js/views/claims/claim-items-common-view.js');
require('frontend/assets/js/views/claims/new-claim-items-common-view.js');
require('frontend/assets/js/views/claims/new-claim-item-view.js');
require('frontend/assets/js/views/claims/claim-item-response-view.js');
require('frontend/assets/js/views/claims/claim-item-responses-view.js');
require('frontend/assets/js/views/claims/claim-item-response-comment-form-view.js');
require('frontend/assets/js/views/claims/claim-item-form-view.js');
require('frontend/assets/js/views/claims/claim-form-tips-view.js');
require('frontend/assets/js/views/claims/claim-item-view.js');
require('frontend/assets/js/views/claims/claim-order-numbers-view.js');
app.YoutubePopupView = require('frontend/assets/js/react/common/es6/views/popups/youtube-popup-view.js').YoutubePopupView;
app.DeletedGiftPopupView = require('frontend/assets/js/react/common/es6/views/popups/deleted-gift-popup-view.js').DeletedGiftPopupView;
require('frontend/assets/js/views/similar-queries-view.js');
app.FooterView = require('frontend/assets/js/react/common/es6/views/footer/footer-view.js').FooterView;
require('frontend/assets/js/views/delivery/delivery-popup-select-view.js');
require('frontend/assets/js/views/delivery/delivery-intervals-view.js');
require('frontend/assets/js/views/checkout/checkout-restricted-items-popup-view.js');
require('frontend/assets/js/views/order-view.js');
require('frontend/assets/js/views/cart/cart-add-by-articul-view.js');
require('frontend/assets/js/views/cart/cart-item-view.js');
require('frontend/assets/js/views/cart/cart-items-view.js');
require('frontend/assets/js/views/cart/gifts-for-actions-view.js');
require('frontend/assets/js/views/cart/gift-for-action-item-view.js');
require('frontend/assets/js/views/countdown-view.js');
require('frontend/assets/js/views/category/category-common-view.js');
require('frontend/assets/js/views/category/category-items-view.js');
require('frontend/assets/js/views/category/category-news-item-view.js');
require('frontend/assets/js/views/category/category-news-items-view.js');
require('frontend/assets/js/views/category/service-category-item-qty-view.js');
require('frontend/assets/js/views/category/category-item-qty-view.js');
require('frontend/assets/js/views/category/category-item-view.js');
require('frontend/assets/js/views/category/category-without-items-view.js');
require('frontend/assets/js/views/category/category-filter-pages-view.js');
require('frontend/assets/js/views/category/category-countdown-view.js');
require('frontend/assets/js/views/category/category-sport-nutrition-view.js');
require('frontend/assets/js/views/category/category-banner-carousel-view.js');
app.CurrencySelectListView  = require('frontend/assets/js/react/common/es6/views/currency/currency-select-list-view.js').CurrencySelectListView;
require('frontend/assets/js/views/currency/currency-select-state-view.js');
app.CurrenciesPopupSelectView = require('frontend/assets/js/react/common/es6/views/choice-city-and-currency/currencies-popup-select-view.js').default;
require('frontend/assets/js/views/choice-city-and-currency/new-currency-select-list-view.js');
require('frontend/assets/js/views/catalog-view.js');
require('frontend/assets/js/views/category/category-promo-top-image-view.js');
require('frontend/assets/js/views/wish-tab-catalog-menu.js');
require('frontend/assets/js/views/offers/offers-list-view.js');
require('frontend/assets/js/views/offers/offer-view.js');
require('frontend/assets/js/views/popups/popup-view.js');
require('frontend/assets/js/views/popups/common-popups-views.js');
require('frontend/assets/js/views/popups/dynamic-popup-view.js');
require('frontend/assets/js/views/popups/manager-contacts-popup-view.js');
require('frontend/assets/js/views/popups/payment-confirmation-popup-view.js');
require('frontend/assets/js/views/popups/confirm-repeat-popup-view.js');
require('frontend/assets/js/views/popups/old-browser-popup-view.js');
require('frontend/assets/js/views/order-history/order-list-view.js');
require('frontend/assets/js/views/order-history/order-item-view.js');
require('frontend/assets/js/views/payment-prepare-view.js');
require('frontend/assets/js/views/tabs-catalog-item-view.js');
require('frontend/assets/js/views/choice-country/choice-country-view.js');
require('frontend/assets/js/views/choice-country/choice-country-popup-view.js');
require('frontend/assets/js/views/choice-ownership-type/choice-ownership-type-view.js');
require('frontend/assets/js/views/choice-ownership-type/choice-ownership-type-popup-view.js');
require('frontend/assets/js/views/user-view.js');
require('frontend/assets/js/views/user-data-view.js');
require('frontend/assets/js/views/user-change-password-form-view.js');
require('frontend/assets/js/views/user-data-form-view.js');
require('frontend/assets/js/views/user-data-phone-list-view.js');
require('frontend/assets/js/views/user-phone-view.js');
require('frontend/assets/js/views/user-delivery-address-view.js');
require('frontend/assets/js/views/user-delivery-address-form-view.js');
require('frontend/assets/js/views/user-delivery-address-list-view.js');
require('frontend/assets/js/views/user-settings-view.js');
require('frontend/assets/js/views/legal-entity-view.js');
require('frontend/assets/js/views/legal-entity-form-view.js');
require('frontend/assets/js/views/legal-entity-list-view.js');
require('frontend/assets/js/views/change-password-form-view.js');
require('frontend/assets/js/views/change-password-view.js');
require('frontend/assets/js/views/cabinet/cabinet-manager-view.js');
app.BodyView = require('frontend/assets/js/react/common/es6/views/body-view.js').BodyView;
app.ChoiceCityItemView = require('frontend/assets/js/react/common/es6/views/choice-city/choice-city-item-view.js').ChoiceCityItemView;
require('frontend/assets/js/views/choice-city/choice-city-contacts-item-view.js');
require('frontend/assets/js/views/choice-city/choice-city-delivery-view.js');
require('frontend/assets/js/views/password-reset-request-form-view.js');
require('frontend/assets/js/views/password-reset-success-form-view.js');
require('frontend/assets/js/views/password-reset-form-view.js');
require('frontend/assets/js/views/login-form-view.js');
require('frontend/assets/js/views/signup-form-view.js');
app.SettlementAutocompleteView = require('frontend/assets/js/react/common/es6/views/settlement-autocomplete-view.js').SettlementAutocompleteView;
require('frontend/assets/js/views/popups/agreement-popup-view.js');
require('frontend/assets/js/views/auth-view.js');
require('frontend/assets/js/views/modifiers-view.js');
require('frontend/assets/js/views/base-video-view.js');
require('frontend/assets/js/views/part-analog-view.js');
require('frontend/assets/js/views/upload-photo-form-view.js');
require('frontend/assets/js/views/wish-list-view.js');
require('frontend/assets/js/views/category-view.js');
require('frontend/assets/js/views/callme-view.js');
require('frontend/assets/js/views/image-view.js');
require('frontend/assets/js/views/image-popup-view.js');
require('frontend/assets/js/views/image-preview-view.js');
require('frontend/assets/js/views/sub-categories-view.js');
require('frontend/assets/js/views/tooltip-view.js');
require('frontend/assets/js/views/informer/informer-list-view.js');
require('frontend/assets/js/views/informer/informer-view.js');
require('frontend/assets/js/views/tabs-delivery-search-city-view.js');
require('frontend/assets/js/views/tabs-site-index-orders-view.js');
require('frontend/assets/js/views/tabs-site-index-collect-view.js');
require('frontend/assets/js/views/tabs-order-history-view.js');
require('frontend/assets/js/views/main-window-view.js');
require('frontend/assets/js/views/message-to-manager-form-view.js');
require('frontend/assets/js/views/message-to-director-form-view.js');
require('frontend/assets/js/views/message-to-call-me-form-contact-group-view.js');
require('frontend/assets/js/views/news-view.js');
require('frontend/assets/js/views/delivery-condition/delivery-condition-view.js');
require('frontend/assets/js/views/toggle-blocks-button-view.js');
require('frontend/assets/js/views/toggle-text-blocks-view.js');
app.GridHeaderView = require('frontend/assets/js/react/common/es6/views/grid-header-view.js').GridHeaderView;
require('frontend/assets/js/views/overlay-view.js');
require('frontend/assets/js/views/cart/cart-gift-view.js');
require('frontend/assets/js/views/gift/gifts-view.js');
require('frontend/assets/js/views/gift/gifts-page-view.js');
require('frontend/assets/js/views/suggest-view.js');
require('frontend/assets/js/views/to-top-view.js');
require('frontend/assets/js/views/act-of-reconciliation-view.js');
require('frontend/assets/js/views/trademarks/darite-schastie-view.js');
require('frontend/assets/js/views/trademarks/las-igras-view.js');
require('frontend/assets/js/views/trademarks/art-uzor-view.js');
require('frontend/assets/js/views/trademarks/tundra-view.js');
require('frontend/assets/js/views/trademarks/collorista-video-view.js');
require('frontend/assets/js/views/trademarks/collorista-view.js');
require('frontend/assets/js/views/trademarks/komandor-view.js');
require('frontend/assets/js/views/trademarks/etel-view.js');
require('frontend/assets/js/views/datepicker-view.js');
require('frontend/assets/js/views/category/category-upakovka-view.js');
require('frontend/assets/js/views/joint-purchase/joint-purchase-payment-form-view.js');
require('frontend/assets/js/views/joint-purchase/joint-purchase-payments-form-view.js');
require('frontend/assets/js/views/joint-purchase/joint-purchase-select-prepayment-view.js');
require('frontend/assets/js/views/joint-purchase/joint-purchase-organizer-form-view.js');
require('frontend/assets/js/views/joint-purchase/joint-purchase-delivery-form-view.js');
require('frontend/assets/js/views/joint-purchase/joint-purchase-delivery-forms-view.js');
require('frontend/assets/js/views/joint-purchase/joint-purchase-delivery-group-forms-view.js');
require('frontend/assets/js/views/joint-purchase/joint-purchase-delivery-address-group-forms-view.js');
require('frontend/assets/js/views/joint-purchase/joint-purchase-delivery-address-forms-view.js');
require('frontend/assets/js/views/joint-purchase/joint-purchase-delivery-address-form-view.js');
require('frontend/assets/js/views/joint-purchase/joint-purchase-delivery-pickup-group-forms-view.js');
require('frontend/assets/js/views/joint-purchase/joint-purchase-delivery-pickup-forms-view.js');
require('frontend/assets/js/views/joint-purchase/joint-purchase-delivery-pickup-form-view.js');
require('frontend/assets/js/views/joint-purchase/joint-purchase-bill-view.js');
require('frontend/assets/js/views/joint-purchase/joint-purchase-organizer-page-view.js');
require('frontend/assets/js/views/joint-purchase/jp-timer-view.js');
require('frontend/assets/js/views/joint-purchase/jp-order-cancellation-popup-view.js');
require('frontend/assets/js/views/joint-purchase/jp-info-view.js');
require('frontend/assets/js/views/volume-discount/tabs-volume-discount-view.js');
app.UploadFilesFormView = require('frontend/assets/js/react/common/es6/views/upload-files-form-view.js').UploadFilesFormView;
require('frontend/assets/js/filters/views/filter-apply-popup-view.js');
require('frontend/assets/js/filters/views/range-filter-view.js');
require('frontend/assets/js/filters/views/checkbox-filter-view.js');
require('frontend/assets/js/filters/views/tree-filter-view.js');
require('frontend/assets/js/filters/views/tree-item-filter-view.js');
require('frontend/assets/js/filters/views/filters-view.js');
require('frontend/assets/js/filters/views/header-view.js');
require('frontend/assets/js/filters/views/compound-filter-view.js');
require('frontend/assets/js/filters/views/select-filter-view.js');
require('frontend/assets/js/filters/views/root-select-filter-view.js');
require('frontend/assets/js/filters/views/chosen-filters-popup-view.js');
require('frontend/assets/js/filters/views/chosen-filters-row-view.js');
require('frontend/assets/js/filters/views/tires-and-wheels-filter-view.js');
require('frontend/assets/js/filters/views/param-popup-filter-view.js');
require('frontend/assets/js/filters/views/car-popup-filter-view.js');
require('frontend/assets/js/views/search-tips-view.js');
require('frontend/assets/js/views/search-bar-view.js');
app.RecommendationsItemView = require('frontend/assets/js/react/common/es6/views/recommendations/recommendations-item-view.js').RecommendationsItemView;
app.RecommendationsItemQtyView = require('frontend/assets/js/react/common/es6/views/recommendations/recommendations-item-qty-view.js').RecommendationsItemQtyView;
app.RecommendationsCarouselView = require('frontend/assets/js/react/common/es6/views/recommendations/recommendations-carousel-view.js').RecommendationsCarouselView;
app.RecommendationsEvents = require('frontend/assets/js/react/common/es6/views/recommendations/recommendations-datalayer-events.js').RecommendationsEvents;
require('frontend/assets/js/views/ecommerce-events.js');
app.OkoEvents = require('frontend/assets/js/react/common/es6/views/oko-events.js').OkoEvents;
app.CategoriesFilterPopupView = require('frontend/assets/js/react/common/es6/views/popups/categories-filter-popup-view.js').CategoriesFilterPopupView;
app.BaseCarouselView = require('frontend/assets/js/react/common/es6/views/owl-carousel/base-carousel-view.js').BaseCarouselView;
app.OwlCarouselView = require('frontend/assets/js/react/common/es6/views/owl-carousel/owl-carousel-view.js').OwlCarouselView;
app.CssCarouselView = require('frontend/assets/js/react/common/es6/views/owl-carousel/css-carousel-view.js').CssCarouselView;
require('frontend/assets/js/views/sp-view.js');
require('frontend/assets/js/views/popups/service-order-popup-view.js');
require('frontend/assets/js/views/popups/service-order-form-view.js');
require('frontend/assets/js/views/popups/not-selected-city-popup.js');
require('frontend/assets/js/models/Preloader.js');
require('frontend/assets/js/views/preloader-view.js');
app.LoaderView = require('frontend/assets/js/react/common/es6/views/loader-view.js').LoaderView;
require('frontend/assets/js/views/personal-recommendations/personal-recommendations-view.js');
require('frontend/assets/js/views/personal-recommendations/personal-recommendations-cart-analog-view.js');
require('frontend/assets/js/views/personal-recommendations/personal-recommendations-search-view.js');
require('frontend/assets/js/views/personal-recommendations/personal-recommendations-category-view.js');
require('frontend/assets/js/views/oko-watcher.js');
require('frontend/assets/js/views/loco-items-view.js');
app.SimpleRefundPopupFormView = require('frontend/assets/js/react/common/es6/views/refund/simple-refund-popup-form-view.js').SimpleRefundPopupFormView;
app.RefundPopupView = require('frontend/assets/js/react/common/es6/views/refund/refund-popup-view.js').RefundPopupView;
app.NotificationsView = require('frontend/assets/js/react/common/es6/views/notification/notifications-view.js').NotificationsView;
app.SearchReviewView = require('frontend/assets/js/react/common/es6/views/search-review/search-review-view').SearchReviewView;
app.RefundFormView = require('frontend/assets/js/react/common/es6/views/refund/refund-form-view.js').RefundFormView;
require('frontend/assets/js/models/vk-events.js');
require('frontend/assets/js/models/joint-purchase.js');
require('frontend/assets/js/models/JointPurchasePaymentsForm.js');
require('frontend/assets/js/models/JointPurchasePrepaymentsForm.js');
require('frontend/assets/js/models/JointPurchaseOrganizer.js');
require('frontend/assets/js/models/Discount.js');
require('frontend/assets/js/models/Country.js');
require('frontend/assets/js/models/ItemComment.js');
require('frontend/assets/js/models/Reaction.js');
require('frontend/assets/js/models/User.js');
require('frontend/assets/js/models/ItemPage.js');
require('frontend/assets/js/models/Item.js');
require('frontend/assets/js/models/CategorySecond.js');
require('frontend/assets/js/models/CartItem.js');
require('frontend/assets/js/models/WishItem.js');
require('frontend/assets/js/models/UserPhone.js');
require('frontend/assets/js/models/UserDeliveryAddress.js');
require('frontend/assets/js/models/LegalEntity.js');
require('frontend/assets/js/models/OwnershipType.js');
require('frontend/assets/js/models/WishCategory.js');
require('frontend/assets/js/models/ProductImage.js');
require('frontend/assets/js/models/Settlement.js');
require('frontend/assets/js/models/SettlementExt.js');
require('frontend/assets/js/models/Message.js');
require('frontend/assets/js/models/CallMe.js');
require('frontend/assets/js/models/CartWishItem.js');
require('frontend/assets/js/models/PasswordResetRequestForm.js');
require('frontend/assets/js/models/LoginForm.js');
require('frontend/assets/js/models/SignupForm.js');
require('frontend/assets/js/models/Order.js');
require('frontend/assets/js/models/OrderForm.js');
require('frontend/assets/js/models/SettlementForm.js');
require('frontend/assets/js/models/UserInformerItem.js');
require('frontend/assets/js/models/DeliveryType.js');
require('frontend/assets/js/models/PaymentType.js');
require('frontend/assets/js/models/PasswordResetForm.js');
require('frontend/assets/js/models/RecentItem.js');
require('frontend/assets/js/models/UpsaleItem.js');
require('frontend/assets/js/models/UpsaleItemRejection.js');
require('frontend/assets/js/models/CartGift.js');
require('frontend/assets/js/models/Manager.js');
require('frontend/assets/js/models/Claim.js');
require('frontend/assets/js/models/ClaimItem.js');
require('frontend/assets/js/models/GroupPurchase.js');
require('frontend/assets/js/models/ManagerGrade.js');
require('frontend/assets/js/models/NewsArticle.js');
require('frontend/assets/js/models/DeliveryInterval.js');
require('frontend/assets/js/models/DeliveryDay.js');
require('frontend/assets/js/models/UnsubscribeByToken.js');
require('frontend/assets/js/models/PromoCodeForm.js');
require('frontend/assets/js/models/JpOrder.js');
require('frontend/assets/js/models/CancellationReasons.js');
require('frontend/assets/js/models/Payment.js');
require('frontend/assets/js/models/ItemQuestion.js');
require('frontend/assets/js/models/ClaimItemRespose.js');
require('frontend/assets/js/models/FilterPage.js');
require('frontend/assets/js/models/PersonalRecommendations.js');
require('frontend/assets/js/models/UserContact.js');
require('frontend/assets/js/models/request-data.js');
require('frontend/assets/js/models/PartHelpPopupForm.js');
require('frontend/assets/js/models/ErrorMessage.js');
require('frontend/assets/js/models/ItemDelivery.js');
require('frontend/assets/js/models/refund-form.js');
app.RefundModel = require('frontend/assets/js/react/common/es6/models/refund-model.js').RefundModel;
app.SearchReview = require('frontend/assets/js/react/common/es6/models/search-review.js').SearchReview;
require('frontend/assets/js/filters/models/RangeFilter.js');
require('frontend/assets/js/filters/models/CheckboxFilter.js');
require('frontend/assets/js/filters/models/TreeItemFilter.js');
require('frontend/assets/js/filters/models/TreeFilter.js');
require('frontend/assets/js/filters/models/SelectFilter.js');
require('frontend/assets/js/filters/models/CompoundFilter.js');
require('frontend/assets/js/models/CarBrands.js');
require('frontend/assets/js/filters/models/Total.js');
require('frontend/assets/js/collections/orders.js');
require('frontend/assets/js/collections/discounts.js');
require('frontend/assets/js/collections/cart.js');
require('frontend/assets/js/collections/category.js');
require('frontend/assets/js/collections/search.js');
require('frontend/assets/js/collections/wish.js');
require('frontend/assets/js/collections/wish-items.js');
require('frontend/assets/js/collections/items.js');
require('frontend/assets/js/collections/settlements.js');
require('frontend/assets/js/collections/user-phones.js');
require('frontend/assets/js/collections/user-delivery-addresses.js');
require('frontend/assets/js/collections/legal-entities.js');
require('frontend/assets/js/collections/ownership-types.js');
require('frontend/assets/js/collections/wish-categories.js');
require('frontend/assets/js/collections/informer.js');
require('frontend/assets/js/collections/cart-wish-items.js');
require('frontend/assets/js/collections/delivery-types.js');
require('frontend/assets/js/collections/payment-types.js');
require('frontend/assets/js/collections/recommendations-items-collection.js');
require('frontend/assets/js/collections/currencies.js');
require('frontend/assets/js/collections/gifts.js');
require('frontend/assets/js/collections/managers.js');
require('frontend/assets/js/collections/recent.js');
require('frontend/assets/js/collections/claims.js');
require('frontend/assets/js/collections/claim-items.js');
require('frontend/assets/js/collections/group-purchases.js');
require('frontend/assets/js/collections/search-tips-cache.js');
require('frontend/assets/js/collections/search-tips.js');
require('frontend/assets/js/collections/districts.js');
require('frontend/assets/js/collections/delivery-intervals.js');
require('frontend/assets/js/collections/delivery-days.js');
require('frontend/assets/js/collections/news.js');
require('frontend/assets/js/collections/jp-orders.js');
require('frontend/assets/js/collections/jp-organizers-pageable.js');
require('frontend/assets/js/collections/item-comments.js');
require('frontend/assets/js/collections/item-questions.js');
app.Counterparties = require('frontend/assets/js/react/common/es6/collections/counterparties.js').Counterparties;
require('frontend/assets/js/collections/claim-item-responses.js');
require('frontend/assets/js/collections/user-contacts.js');
require('frontend/assets/js/collections/cart-item-delivery.js');
require('frontend/assets/js/collections/gift-sets.js');
app.NewsSearch = require('frontend/assets/js/react/common/es6/collections/news-search.js').NewsSearch;
require('frontend/assets/js/collections/our-legal-entities.js');
app.ItemDeliveryCollection = require('frontend/assets/js/react/common/es6/collections/item-delivery-collection.js').ItemDeliveryCollection;
app.OrderConditions = require('frontend/assets/js/react/common/es6/models/order-conditions').OrderConditions;
app.OrderProgress = require('frontend/assets/js/react/common/es6/models/order-progress').OrderProgress;
app.BankDetailsCollection = require('frontend/assets/js/react/common/es6/collections/bank-details-collection.js').BankDetailsCollection;
app.SeoTextView = require('frontend/assets/js/react/common/es6/views/seo-text-view/seo-text-view.js').SeoTextView;
require('frontend/assets/js/views/vk-comment-view.js');
require('frontend/assets/js/views/spoiler-contests-view.js');
require('frontend/assets/js/views/delivery-wh-links-view.js');
require('frontend/assets/js/views/unsubscribe-message-view.js');
require('frontend/assets/js/views/unsubscribe-view.js');
require('frontend/assets/js/views/district-popup-view.js');
require('frontend/assets/js/views/sale-popup-view.js');
require('frontend/assets/js/views/collorista-callme-form-view.js');
require('frontend/assets/js/views/social-signup-form-view.js');
require('frontend/assets/js/views/counterparty-view.js');
require('frontend/assets/js/views/user-data-new-view.js');
require('frontend/assets/js/views/user-data-new-form-view.js');
require('frontend/assets/js/views/user-data-contact-list-view.js');
require('frontend/assets/js/views/user-data-contact-view.js');
require('frontend/assets/js/views/info-delivery-page-view.js');
app.DynamicItemDeliveryView = require('frontend/assets/js/react/common/es6/views/dynamic-item-delivery-view.js').DynamicItemDeliveryView;
require('frontend/assets/js/app.js');

}.call(window));